






























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "MonitoringWidget",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => "",
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
});
